import _ from "underscore"
import messageResource from "../../messageResource"
import {ReportGroupingLevel} from "../../reports/constants";
import BasePDFDefinitionColumnBuilder, * as BaseColumnBuilder from "../BasePDFDefinitionColumnBuilder";

class PDFDefinitionColumnBuilder extends BasePDFDefinitionColumnBuilder {
    init(config, rowSpanNumber) {
        super.init(config, rowSpanNumber);

        if (config.fourthGroupingLevel == ReportGroupingLevel.USER)
            this.valueMask[3] = function(column) { return column.isUserMasked ? {msg: ""} : false; };

        return this;
    }
}

export class Totals extends BaseColumnBuilder.Totals {
    init(config, rowSpanNumber) {
        super.init(config, rowSpanNumber);

        if (config.fourthGroupingLevel == ReportGroupingLevel.USER)
            this.valueMask[3] = function(column) { return !_.isUndefined(column.isUserMasked) && column.isUserMasked ? {msg: ""} : false; };

        return this;
    }
}

export class Levels extends BaseColumnBuilder.Levels {
    init(config, store, rowSpanNumber) {
        super.init(config, rowSpanNumber);

        this.store = store;
        this.groupingLevels = [config.firstGroupingLevel, config.secondGroupingLevel, config.thirdGroupingLevel, config.fourthGroupingLevel];
        this.reportGroupingStyles = ["reportFirstGroupingRow", "reportSecondGroupingRow", "reportThirdGroupingRow", "reportFourthGroupingRow"];
        this.reportGroupingMargins = ["reportFirstGroupingRowMargin", "reportSecondGroupingRowMargin", "reportThirdGroupingRowMargin", "reportFourthGroupingRowMargin"];

        this.isWide = !config.includeNotEstimated;
        this.maxUserNameLen = 14;

        return this;
    }

    _makeCustomRow(style, groupingLevel, identity) {
        var text = this._getTitle(groupingLevel, identity, this.maxUserNameLen);
        return this._makeRowDefinition(style, text);
    }

    pushWidth(destination, sizes) {
        var baseWidth = this.isWide ? sizes["levelsWide"] : sizes["levels"];
        destination.push(baseWidth + '%');
    }

    makeHeader() {
        var names = [];
        for (var i = 0; i < 4; i++) {
            if (this.groupingLevels[i] != ReportGroupingLevel.NONE) {
                names.push(this.formatUtil.formatGroupingLevel(this.groupingLevels[i]));
            }
        }
        return this._makeHeaderDefinition(names.join(' / '), [this.tableHeaderStyleNoMargin, "reportLevelsTitle"]);
    }

    makeTotals() {
        return this._makeRowDefinition("reportTotal", messageResource.getMessage("report.total"));
    }

    makeRow(lvl, data) {
        return this._makeCustomRow([this.reportGroupingStyles[lvl], this.reportGroupingMargins[data.level]], this.groupingLevels[lvl], data.id);
    }
}

export class TotalSpentTime extends Totals {
    _getValue(data) {
        return data.totalSpentTime;
    }

    makeHeader() {
        return this._makeHeaderDefinition(messageResource.getMessage("report.budgeted_vs_actual.spent_time.total"), this.reportTitleBigMargin);
    }
}

export class SpentTimeForNotEstimated extends Totals {
    _getValue(data) {
        return data.spentTimeForNotEstimated;
    }

    makeHeader() {
        return this._makeHeaderDefinition(messageResource.getMessage("report.budgeted_vs_actual.spent_time.nonbudgeted"), this.reportTitleSmallMargin);
    }
}

export class EstimatedTime extends Totals {
    constructor() {
        super();
        this.isUserMasked = true;
    }

    _getValue(data) {
        return data.estimatedTime;
    }

    makeHeader() {
        return this._makeHeaderDefinition(messageResource.getMessage("report.budgeted_vs_actual.budgeted"), this.reportTitleNormalMargin);
    }
}

export class SpentTimeForEstimated extends Totals {
    _getValue(data) {
        return data.spentTimeForEstimated;
    }

    makeHeader() {
        return this._makeHeaderDefinition(messageResource.getMessage("report.budgeted_vs_actual.spent_time"), this.reportTitleNormalMargin);
    }
}

export class VarianceTime extends PDFDefinitionColumnBuilder {
    constructor() {
        super();
        this.isUserMasked = true;
    }

    pushWidth(destination, sizes) {
        destination.push(sizes["variance"] + '%');
        destination.push(sizes["variance"] + '%');
    }

    makeHeader() {
        var varianceTxt = [
            {text: messageResource.getMessage("report.budgeted_vs_actual.variance")},
            {text: "\n(" + messageResource.getMessage("report.budgeted_vs_actual.budgeted_minus_spent") + ")", style: this.tinyText}
        ];

        return [
            {
                style: this.tableHeaderStyle,
                text: varianceTxt,
                colSpan: 2
            }, {}
        ];
    }

    makeSubHeader() {
        return [
            {
                style: this.tableHeaderStyle,
                text: messageResource.getMessage("report.budgeted_vs_actual.variance.mh")
            },
            {
                style: this.tableHeaderStyle,
                text: messageResource.getMessage("report.budgeted_vs_actual.variance.percent")
            }
        ];
    }

    _makeRow(style, data, valueMask) {
        var invalidPercentage = (!_.isUndefined(data.estimatedTime) && data.estimatedTime < 0.0001);
        return [
            this.makeTimeCell(data.varianceTime, style, valueMask(this, data)),
            this.makePercentCell(invalidPercentage ? null : data.varianceTimeInPercentage, style, valueMask(this, data))
        ];
    }
}

export class EstimatedTasksBlock extends PDFDefinitionColumnBuilder {
    constructor() {
        super();
        this.cellMasks = [
            {isUserMasked: false},
            {isUserMasked: true, maskedTaskValue: {msg: messageResource.getMessage("report.budgeted_vs_actual.not_budgeted"), style: "notEstimated"}},
            {isUserMasked: true},
            {isUserMasked: true, maskedTaskValue: {msg: "-"}}
        ]
    }

    init(config, store, rowSpanNumber) {
        super.init(config, rowSpanNumber);

        var lvls = [config.firstGroupingLevel, config.secondGroupingLevel, config.thirdGroupingLevel, config.fourthGroupingLevel];
        for (var i = 0; i < 4; i++) {
            if (lvls[i] == ReportGroupingLevel.TASK)
                this.valueMask[i] = function(column, data) {
                    return !_.isUndefined(column.maskedTaskValue) && !store.getTask(data.id).estimated ? column.maskedTaskValue : false;
                };
        }

        return this;
    }

    pushWidth(destination, sizes) {
        destination.push(sizes["estimatedTime"] + '%');
        destination.push(sizes["estimatedTime"] + '%');
        destination.push(sizes["variance"] + '%');
        destination.push(sizes["variance"] + '%');
    }

    makeHeader() {
        return [
            {
                style: this.tableHeaderStyle,
                text: messageResource.getMessage("report.budgeted_vs_actual.spent.budgeted_tasks"),
                colSpan: 4
            }, {}, {}, {}
        ];
    }

    makeSubHeader() {
        var varianceTxt = [
            {text: messageResource.getMessage("report.budgeted_vs_actual.variance")},
            {text: "(" + messageResource.getMessage("report.budgeted_vs_actual.budgeted_minus_spent") + ")", style: this.tinyText}
        ];

        return [
            {
                style: this.tableSubHeaderWithMarginStyle,
                text: messageResource.getMessage("report.budgeted_vs_actual.spent_time"),
                rowSpan: 2
            },
            {
                style: this.tableSubHeaderWithMarginStyle,
                text: messageResource.getMessage("report.budgeted_vs_actual.budgeted"),
                rowSpan: 2
            },
            {
                style: this.tableSubHeaderStyle,
                stack: varianceTxt,
                colSpan: 2
            }, {}
        ];
    }

    makeThirdLvlHeader() {
        return [
            {}, {},
            {
                style: this.tableThirdLvlHeaderStyle,
                text: messageResource.getMessage("report.budgeted_vs_actual.variance.mh")
            },
            {
                style: this.tableThirdLvlHeaderStyle,
                text: messageResource.getMessage("report.budgeted_vs_actual.variance.percent")
            }
        ];
    }

    _makeRow(style, data, valueMask) {
        var invalidPercentage = (!_.isUndefined(data.estimatedTime) && data.estimatedTime < 0.0001);
        return [
            this.makeTimeCell(data.spentTimeForEstimated, style, valueMask(this.cellMasks[0], data)),
            this.makeTimeCell(data.estimatedTime, style, valueMask(this.cellMasks[1], data)),
            this.makeTimeCell(data.varianceTime, style, valueMask(this.cellMasks[2], data)),
            this.makePercentCell(invalidPercentage ? null : data.varianceTimeInPercentage, style, valueMask(this.cellMasks[3], data))
        ];
    }
}



// WEBPACK FOOTER //
// ./web/js/pdf/evaReport/PDFDefinitionColumnBuilder.js